// ======================== SELECT ======================== //
const GET_DOCUMENT = `
query Myquery($where: document_bool_exp, $orderBy: [document_order_by!], $offset: Int, $limit: Int) {
  document(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code_system
    code_court
    code_office
    code_agency
    code_area
    number_decision
    content_document
    date_issued
    date_invite
    name_litigant
    address
    state_id
    state {
      id
      name
    }
    district_id
    district {
      id
      name
    }
    ward_id
    ward {
      id
      name
    }
    date_receipt_court
    date_complete
    date_return_court
    is_fee_budget
    signer
    is_urgent
    type_document
    cost_document
    date_month_td
    status_tongdat {id code name}
    status_document {id code name ordinal}
  }
}
`
const GET_SALARY_DOCUMENT = `
query get_salary_document($where: document_bool_exp, $orderBy: [document_order_by!], $offset: Int, $limit: Int) {
  document(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code_system
    code_court
    code_office
    office_tpl {
      id
      code
    }
    code_agency
    code_area
    number_decision
    content_document
    date_issued
    date_invite
    name_litigant
    address
    state_id
    state {
      id
      name
    }
    district_id
    district {
      id
      name
    }
    ward_id
    ward {
      id
      name
    }
    date_receipt_court
    date_return_court
    date_change_tdv
    date_complete
    type_document
    reason_delay
    status_td_id
    status_tongdat {id code name}
    status_vb_id
    status_document {id code name ordinal}
    tdv {id fullname}
    is_full_salary
    compute_full_salary
    is_late_salary
    compute_late_salary
    is_late
    amount_salary
    is_confirm_salary
    date_comfirm_salary
    date_upd_salary
    phone_litigant
    date_month_td
  }
  document_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`
const GET_DOCUMENT_PROVINCE = `
query Myquery($where: document_bool_exp, $orderBy: [document_order_by!], $offset: Int, $limit: Int) {
  document(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code_system
    code_court
    code_office
    code_agency
    content_document
    name_litigant
    address
    state_id
    state {
      id
      name
    }
    district_id
    district {
      id
      name
    }
    ward_id
    ward {
      id
      name
    }
    office_vplk {id name code}
    date_receipt_court
    date_return_court
    date_tdv_receipt
    date_complete
    type_document
    cost_document
    amount_salary
    is_confirm_salary
    status_tongdat {id name code}
    status_document {id name code}
    tdv {id fullname code}
    date_comfirm_salary
    date_upd_salary
  }
}
`
const GET_REPORT = `
query get_salary_document($where: document_bool_exp, $orderBy: [document_order_by!], $offset: Int, $limit: Int) {
  document(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code_system
    code_court
    code_agency
    number_decision
    content_document
    date_issued
    date_invite
    name_litigant
    address
    state_id
    state {
      id
      name
      type
    }
    district_id
    district {
      id
      name
    }
    ward_id
    ward {
      id
      name
    }
    signer
    type_document
    date_receipt_court
    date_return_court
    date_tdv_receipt
    date_tdv_return
    is_urgent
    reason_delay
    status_td_id
    status_tongdat {id code name}
    status_vb_id
    status_document {id code name ordinal}
    tdv {id fullname}
    is_fee_budget
    cost_document
    date_complete
    date_month_td
    count_day_done
  }
}
`
const GET_STATE = `
query get_state($where: state_bool_exp, $orderBy: [state_order_by!], $offset: Int, $limit: Int) {
  state(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
  }
}
`
const GET_DISTRICT = `
query get_district($where: district_bool_exp, $orderBy: [district_order_by!], $offset: Int, $limit: Int) {
  district(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
    state_id
    state {
      id
    }
  }
}
`
const GET_WARD = `
query get_ward($where: ward_bool_exp, $orderBy: [ward_order_by!], $offset: Int, $limit: Int) {
  ward(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
    district_id
    district {
      id
    }
  }
}
`
const GET_OFFICE_TPL = `
query get_office_tpl($where: office_tpl_bool_exp, $orderBy: [office_tpl_order_by!], $offset: Int, $limit: Int) {
  office_tpl(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
    code
  }
}
`
const GET_OFFICE_AGENCY = `
query get_office_agency($where: office_agency_bool_exp, $orderBy: [office_agency_order_by!], $offset: Int, $limit: Int) {
  office_agency(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
    code
  }
  office_agency_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`

const GET_REPORT_OFFICE_AGENCY = `
query get_office_agency($where: office_agency_bool_exp, $orderBy: [office_agency_order_by!], $offset: Int, $limit: Int) {
  office_agency(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    name
    code
    rel_office_agency_tpl_codes {
      codes
    }
  }
  office_agency_full:office_agency(order_by: $orderBy, where: $where) {
    id
    name
    code
  }
  office_agency_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`

const GET_AREA = `
query get_area($where: area_bool_exp, $orderBy: [area_order_by!], $offset: Int, $limit: Int) {
  area(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code
  }
}
`
const GET_AREA_COMMON = `
query MyQuery {
            area(where: {deleted: {_eq: false}}) {
              id
              code
            }
          }
`
const GET_SETTING_CURRENT_DOCUMENT = `
query MyQuery($where: setting_current_document_bool_exp, $orderBy: [setting_current_document_order_by!], $offset: Int, $limit: Int) {
  setting_current_document(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    current
  }
}
`
const GET_USERS_WARD = `
query MyQuery($where: users_ward_bool_exp, $orderBy: [users_ward_order_by!], $offset: Int, $limit: Int, $distinct_on: [users_ward_select_column!]) {
  users_ward(order_by: $orderBy, where: $where, offset: $offset, limit: $limit, distinct_on: $distinct_on) {
    user_id
    ward_id
    user {
      id
      fullname
      phone
    }
  }
}
`
const GET_USERS_STATE = `
query MyQuery($where: users_state_bool_exp, $orderBy: [users_state_order_by!], $offset: Int, $limit: Int, $distinct_on: [users_state_select_column!]) {
  users_state(order_by: $orderBy, where: $where, offset: $offset, limit: $limit, distinct_on: $distinct_on) {
    user_id
    state_id
    user {
      id
      fullname
      phone
    }
  }
}
`

const GET_STATEMENT_DETAIL = `
query get_statement_detail($where: users_bool_exp, $orderBy: [users_order_by!], $offset: Int, $limit: Int, $date_from: timestamptz, $date_to: timestamptz) {
  users(where: $where, order_by: $orderBy, offset: $offset, limit: $limit) {
    fullname
    id
    code
    area_id
    view_tdv_total_doc_confirmed_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_normal_kt_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_normal_ny_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_normal_tt_gn_nt3_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_type3_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_type4_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_type5_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_waiting_no_scan_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_complete_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_remaining_aggregate(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_tdv_total_doc_waiting_no_scan(where: {date_receipt_court: {_gte: $date_from, _lte: $date_to}}) {
      document {
        id
        code_system
        code_court
        number_decision
        content_document
        date_issued
        date_invite
        name_litigant
        address
        state_id
        state { id name }
        district_id
        district { id name }
        ward_id
        ward { id name }
        signer
        code_agency
        date_receipt_court
        is_urgent
        type_document
        note
      }
    }
  }
}
`
const GET_PAYROLL_EMPLOYEE = `
query get_statement_detail($where: users_bool_exp, $orderBy: [users_order_by!], $offset: Int, $limit: Int, $date_from: timestamptz, $date_to: timestamptz) {
  users(where: $where, order_by: $orderBy, offset: $offset, limit: $limit) {
    fullname
    id
    areas {
      id
      code
    }
    view_payroll_type1_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type1_late_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type2_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type2_late_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type3_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type3_late_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type4_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type5_aggregate(where: {date_return_court: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
  }
}
`
const GET_PAYROLL_EMPLOYEE_1 = `
query get_statement_detail($where: users_bool_exp, $orderBy: [users_order_by!], $offset: Int, $limit: Int, $date_from: timestamptz, $date_to: timestamptz) {
  users(where: $where, order_by: $orderBy, offset: $offset, limit: $limit) {
    fullname
    id
    areas {
      id
      code
    }
    view_payroll_type1_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type1_late_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type2_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type2_late_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
    view_payroll_type3_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type3_late_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type4_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
      }
    }
    view_payroll_type5_aggregate(where: {date_comfirm_salary: {_gte: $date_from, _lte: $date_to}}) {
      aggregate {
        count
        sum {
          amount_salary
        }
      }
    }
  }
}
`
const GET_STATUS_TONGDAT = `
query get_status_tongdat($where: status_tongdat_bool_exp, $orderBy: [status_tongdat_order_by!], $offset: Int, $limit: Int) {
  status_tongdat(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    code
    name
    delay_time
  }
}
`
const GET_SALARY_PRICELIST = `
query get_salary_pricelist($where: salary_pricelist_bool_exp, $orderBy: [salary_pricelist_order_by!], $offset: Int, $limit: Int) {
  salary_pricelist(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    office_tpl_id
    district_id
    ward_id
    type1_normal 
    type1_late 
    type2_normal 
    type2_late 
    type3_normal 
    type3_late 
    type4_normal 
    type4_late 
  }
}
`
const GET_ORGAN_PRICELIST = `
query get_organ_pricelist($where: organ_pricelist_bool_exp, $childWhere: organ_pricelist_detail_bool_exp, $orderBy: [organ_pricelist_order_by!], $offset: Int, $limit: Int) {
  organ_pricelist(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    office_tpl_id
    office_agency_id
    organ_pricelist_detail(where: $childWhere) {
      district_id
      type1
      type2
      type3
      type4
    }
  }
}
`
const GET_ORGAN_PRICELIST_PROVINCE = `
query get_salary_pricelist_province($where: salary_pricelist_province_bool_exp, $orderBy: [salary_pricelist_province_order_by!], $offset: Int, $limit: Int) {
  salary_pricelist_province(order_by: $orderBy, where: $where, offset: $offset, limit: $limit) {
    id
    office_vplk_id
    office_tpl_id
    state_id
    price
  }
}
`




const GET_REPORT_DOCS_TDV = `
query get_report_docs_tdv($where: users_bool_exp, $orderBy: [users_order_by!], $offset: Int, $limit: Int, $date_from: timestamptz, $date_to: timestamptz, $code_agency: [String!], $type_document: [Int!]) {
  users(where: $where, order_by: $orderBy, offset: $offset, limit: $limit) {
    fullname
    id
    code
    area_id
    areas {id name:code}
    total_received_documents_not_scanned:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "CONFIRMED"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_number_of_documents_being_served:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "DOING"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_docs_sent_back_to_unit:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "RETURN_DPV"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_documents_received_by_coordinator:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "DPV_RECEIPT"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_documents_resubmitted:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "REQUEST_COMPLETE"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_documents_completed:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "COMPLETE"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_docs_returned_to_agency:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "RETURN_AGENCY"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
    total_documents_processed_for_salary:view_common_status_std_total_doc_aggregate(where: {code: {_eq: "SALARY"},date_receipt_court: {_gte: $date_from, _lte: $date_to}, code_agency: {_in: $code_agency}, type_document: {_in: $type_document}}) {
      aggregate {
        count
      }
    }
  }
}
`


// ======================== INSERT ======================== //
const CREATE_DOCUMENT = `
mutation create_document($object: [document_insert_input!]! ) {
  insert_document(objects: $object) {
    affected_rows
    returning {
      id
    }
  }
}
`

// ======================== UPDATE ======================== //
const UPDATE_DOCUMENT = `
mutation update_document($objWhere: document_bool_exp!, $objInput: document_set_input) {
  update_document(where: $objWhere, _set: $objInput) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_SETTING_CURRENT_DOCUMENT = `
mutation update_setting_current_document($objWhere: setting_current_document_bool_exp!, $objInput: setting_current_document_set_input) {
    update_setting_current_document(where: $objWhere, _set: $objInput) {
      affected_rows
      returning {
        id
      }
    }
  }
`

// ======================== DELETE ======================== //
const DELETE_DOCUMENT = `
mutation delete_document($objWhere: document_bool_exp!) {
  delete_document(where: $objWhere) {
    affected_rows
  }
}
`
const GET_OFFICE_TPL_COMMON = `
query MyQuery {
            office_tpl(where: {deleted: {_eq: false}}) {
              id
              code
            }
          }
`

export default {
  // * ================ SELECT ================ *
  GET_DOCUMENT: GET_DOCUMENT,
  GET_SALARY_DOCUMENT: GET_SALARY_DOCUMENT,
  GET_DOCUMENT_PROVINCE: GET_DOCUMENT_PROVINCE,
  GET_STATE: GET_STATE,
  GET_DISTRICT: GET_DISTRICT,
  GET_WARD: GET_WARD,
  GET_OFFICE_TPL: GET_OFFICE_TPL,
  GET_OFFICE_TPL_COMMON: GET_OFFICE_TPL_COMMON,
  GET_OFFICE_AGENCY: GET_OFFICE_AGENCY,
  GET_REPORT_OFFICE_AGENCY: GET_REPORT_OFFICE_AGENCY,
  GET_SETTING_CURRENT_DOCUMENT: GET_SETTING_CURRENT_DOCUMENT,
  GET_USERS_WARD: GET_USERS_WARD,
  GET_USERS_STATE: GET_USERS_STATE,
  GET_AREA: GET_AREA,
  GET_AREA_COMMON: GET_AREA_COMMON,
  GET_STATEMENT_DETAIL: GET_STATEMENT_DETAIL,
  GET_STATUS_TONGDAT: GET_STATUS_TONGDAT,
  GET_SALARY_PRICELIST: GET_SALARY_PRICELIST,
  GET_ORGAN_PRICELIST: GET_ORGAN_PRICELIST,
  GET_ORGAN_PRICELIST_PROVINCE: GET_ORGAN_PRICELIST_PROVINCE,
  GET_PAYROLL_EMPLOYEE: GET_PAYROLL_EMPLOYEE,
  GET_PAYROLL_EMPLOYEE_1: GET_PAYROLL_EMPLOYEE_1,
  GET_REPORT: GET_REPORT,
  GET_REPORT_DOCS_TDV: GET_REPORT_DOCS_TDV,

  // * ================ UPDATE ================ *
  CREATE_DOCUMENT: CREATE_DOCUMENT,
  UPDATE_SETTING_CURRENT_DOCUMENT: UPDATE_SETTING_CURRENT_DOCUMENT,

  // * ================ CREATE ================ *
  UPDATE_DOCUMENT: UPDATE_DOCUMENT,

  // * ================ DELETE ================ *
  DELETE_DOCUMENT: DELETE_DOCUMENT
}
